export enum DisplayMode {
  BrowserExtension = 'BrowserExtension'
}
